<template>
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li><a class="text-500 no-underline line-height-3 cursor-pointer">Reportes</a></li>
    <li class="px-2"><i class="pi pi-angle-right text-500 line-height-3"></i></li>
    <li>
      <router-link to="/reportes/clientes">
        <span class="text-500 line-height-3">Reporte de Clientes</span>
      </router-link>
    </li>
    <li class="px-2"><i class="pi pi-angle-right text-500 line-height-3"></i></li>
    <li><span class="text-900 line-height-3 active">Detalle</span></li>
  </ul>

  <div class="surface-section px-4 py-5 md:px-12 lg:px-12 border-2">
    <div class="flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
      <h4 class="m-0">
        <strong>DETALLE DE VENTAS PARA CLIENTE: {{ ventas[0]?.cliente || '' }} </strong>
      </h4>
      <Button @click="goBack" class="p-button-outlined p-button-secondary p-button-sm">
        <i class="pi pi-arrow-left mr-1"></i> ATRÁS
      </Button>
    </div>

    <DataTable
      ref="dtclienteventas"
      :value="ventas"
      :loading="cargando"
      :rowHover="true"
      class="p-datatable-sm"
      responsiveLayout="scroll"
      showGridlines
      :paginator="true"
      :rows="50"
      :rowsPerPageOptions="[25, 50, 100, 200]"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
      currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} registros"
      :rowClass="filaClase"
    >
      <template #empty>
        <div class="text-center p-4 text-500">
          <i class="pi pi-inbox" style="font-size: 2rem"></i>
          <p class="mt-2">No se encontraron ventas para este cliente.</p>
        </div>
      </template>
      <template #loading>
        <div class="flex align-items-center justify-content-center p-4">
          <ProgressSpinner style="width: 28px; height: 28px" />
          <span class="ml-3 text-600">Cargando ventas...</span>
        </div>
      </template>

      <Column header="#" style="width: 2rem; text-align: center">
        <template #body="slotProps">
          <span class="c-idx">{{ slotProps.index + 1 }}</span>
        </template>
      </Column>

      <Column field="id_venta" header="COD">
        <template #body="slotProps">
          <span v-if="esPrimera(slotProps.index)" class="c-cod">
            {{ slotProps.data.id_venta }}
          </span>
        </template>
      </Column>

      <Column field="fecha_venta" header="FECHA" style="width: 6rem">
        <template #body="slotProps">
          <span v-if="esPrimera(slotProps.index)" class="c-fecha">
            {{ soloFecha(slotProps.data.fecha_venta) }}
          </span>
        </template>
      </Column>

      <Column field="usuario" header="USUARIO">
        <template #body="slotProps">
          <span v-if="esPrimera(slotProps.index)" class="c-usuario">
            {{ slotProps.data.usuario }}
          </span>
        </template>
      </Column>

      <Column field="codigo_interno" header="COD.INT">
        <template #body="slotProps">
          <span class="c-mono">{{ slotProps.data.codigo_interno || '—' }}</span>
        </template>
      </Column>

      <Column field="codigo_origen" header="COD.ORIG">
        <template #body="slotProps">
          <span class="c-mono">{{ slotProps.data.codigo_origen || '—' }}</span>
        </template>
      </Column>

      <Column field="producto" header="PRODUCTO / SERVICIO" style="min-width: 260px">
        <template #body="slotProps">
          <span class="c-producto">{{ slotProps.data.producto }}</span>
        </template>
      </Column>

      <Column field="cantidad" header="CANT." style="text-align: right">
        <template #body="slotProps">
          <span class="c-num">{{ slotProps.data.cantidad }}</span>
        </template>
      </Column>

      <Column field="precio_producto" header="P.UNIT." style="text-align: right">
        <template #body="slotProps">
          <span class="c-num">{{ formatNum(slotProps.data.precio_producto) }}</span>
        </template>
      </Column>

      <Column field="descuento" header="DESC." style="text-align: right">
        <template #body="slotProps">
          <span class="c-desc">{{ formatNum(slotProps.data.descuento || 0) }}</span>
        </template>
      </Column>

      <Column field="total_cancelar" header="T.VENTA" style="text-align: right">
        <template #body="slotProps">
          <span v-if="esPrimera(slotProps.index)" class="c-total">
            {{ formatNum(slotProps.data.total_cancelar) }}
          </span>
        </template>
      </Column>

      <Column field="observacion" header="OBSERVACIÓN">
        <template #body="slotProps">
          <span v-if="esPrimera(slotProps.index) && slotProps.data.observacion" class="c-obs">
            {{ slotProps.data.observacion }}
          </span>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import ClienteService from '@/service/ClienteService'

export default {
  data() {
    return {
      idCliente: this.$route.params.id,
      ventas: [],
      cargando: false
    }
  },
  clienteService: null,
  created() {
    this.clienteService = new ClienteService()
  },
  mounted() {
    this.cargarVentas()
  },
  methods: {
    cargarVentas() {
      this.cargando = true
      this.clienteService
        .showClienteVentas(this.idCliente)
        .then((data) => {
          this.ventas = data.ventas || []
        })
        .catch(() => {
          this.ventas = []
        })
        .finally(() => {
          this.cargando = false
        })
    },

    esPrimera(index) {
      if (index === 0) return true
      return this.ventas[index].id_venta !== this.ventas[index - 1].id_venta
    },

    filaClase(data) {
      const ids = [...new Set(this.ventas.map((v) => v.id_venta))]
      const pos = ids.indexOf(data.id_venta)
      return pos % 2 === 0 ? 'fila-par' : 'fila-impar'
    },

    soloFecha(fechaStr) {
      if (!fechaStr) return ''
      return fechaStr.toString().split(' ')[0]
    },

    formatNum(num) {
      if (num === null || num === undefined || num === '') return '0,00'
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(num)
    },

    goBack() {
      this.$router.push('/reportes/clientes')
    }
  }
}
</script>

<style scoped lang="scss">
:deep(.tabla-compacta .p-datatable-tbody > tr > td) {
  padding: 3px 6px !important;
  line-height: 1.3;
}
:deep(.tabla-compacta .p-datatable-thead > tr > th) {
  padding: 5px 6px !important;
  font-size: 0.76rem;
  white-space: nowrap;
}

:deep(.fila-par) td {
  background: #ffffff !important;
}
:deep(.fila-impar) td {
  background: #eef4ff !important;
}

.c-idx {
  color: #000000;
}
.c-cod {
  font-weight: 700;
  color: #1e3a5f;
}
.c-fecha {
  font-weight: 600;
  color: #000000;
}
.c-usuario {
  color: #000000;
}
.c-mono {
  font-family: monospace;
  color: #000000;
}
.c-producto {
  font-weight: 700;
  color: #000000;
}
.c-num {
  font-weight: 700;
  color: #000000;
}
.c-desc {
  font-weight: 700;
  color: #c2410c;
}
.c-total {
  font-weight: 700;
  color: #15803d;
}
.c-obs {
  color: #000000;
  font-style: italic;
}
</style>
